import type { SVGProps } from "react";
export interface MessageIndicatorIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function MessageIndicatorIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: MessageIndicatorIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M.875 16V6A4.125 4.125 0 0 1 5 1.875h8.175l.116.006a1.125 1.125 0 0 1 0 2.238l-.116.006H5c-1.036 0-1.875.84-1.875 1.875v10c0 1.036.84 1.875 1.875 1.875h2c.62 0 1.125.504 1.125 1.125v1.77l3.534-2.25a4.13 4.13 0 0 1 2.215-.645H19c1.035 0 1.874-.84 1.875-1.875v-5.482a1.125 1.125 0 0 1 2.25 0V16A4.125 4.125 0 0 1 19 20.125h-5.126c-.268 0-.531.056-.773.166l-.233.128L9.14 22.79c-1.414.9-3.266-.115-3.266-1.791v-.873H5A4.125 4.125 0 0 1 .875 16"
      />
      <path
        fill={color}
        d="M16 10.628a.62.62 0 0 0-.124.372l.011.126a.6.6 0 0 0 .113.245zm1 .743a.62.62 0 0 0 0-.743zM12.625 11a.62.62 0 0 0-.124-.372v.743a.62.62 0 0 0 .124-.371m-1.125-.372a.62.62 0 0 0-.124.372l.011.126a.6.6 0 0 0 .113.245zM8.125 11A.62.62 0 0 0 8 10.628v.743A.62.62 0 0 0 8.125 11M7 10.628a.62.62 0 0 0-.125.372l.012.126a.6.6 0 0 0 .113.245zM20.875 4.5a1.376 1.376 0 1 0-2.752.001 1.376 1.376 0 0 0 2.752 0ZM9.125 11A1.625 1.625 0 1 1 7.5 9.375l.167.008A1.625 1.625 0 0 1 9.125 11m4.5 0A1.625 1.625 0 1 1 12 9.375l.167.008c.82.083 1.46.776 1.46 1.617Zm4.5 0A1.625 1.625 0 1 1 16.5 9.375l.166.008c.82.083 1.46.776 1.46 1.617Zm5-6.5a3.625 3.625 0 1 1-7.25-.001 3.625 3.625 0 0 1 7.25.001"
      />
    </svg>
  );
}
